import React from 'react';
import {FileItem} from "../FileItem/FileItem";
import Empty from "../../../../../../common/components/Empty";
import styles from "./styles.module.scss";


export function FileList({
                           fileList = [],
                           handleCloseModal,
                           showFileTypeColumn = true,
                           allowDownloadFile = true,
                           allowDeleteFile = true,
                           allowSelectFile = false,
                           fileTypeID,
                           fileActions
                         }) {
  const gotFiles = fileList && fileList.length > 0;
  const mapFiles = file => {
    const {
      fileID,
      fileName,
      fileTypeName
    } = file;

    return (
      <FileItem
        fileData={{
          fileName,
          fileID,
          fileTypeName,
          fileTypeID,
        }}
        showFileTypeColumn={showFileTypeColumn}
        allowDownloadFile={allowDownloadFile}
        allowDeleteFile={allowDeleteFile}
        allowSelectFile={allowSelectFile}
        fileActions={fileActions}
        handleCloseModal={handleCloseModal}
      />
    )
  };

  const scrollPaddingStyle = fileList.length > 7 ? '13px' : '0px';
  const scrollPadding = fileList.length > 7 ? {paddingLeft: '40px'} : {};
  const gridStyles = {
    overflowY: 'auto',
    overflowX: 'hidden',
    maxHeight: '495px',
    paddingLeft: scrollPaddingStyle,
    width: '100%'
  };

  return (
    <>
      {gotFiles
        ? (
          <>
            <div
              className={styles.filesList}
              style={scrollPadding}
            >
              <div>שם הקובץ</div>
              {showFileTypeColumn && <div>סוג</div>}
              {allowDeleteFile && <div>מחיקה</div>}
              {allowDownloadFile && <div>הורדה</div>}
              {allowSelectFile && <div>בחר</div>}
            </div>
            <div style={gridStyles}>
              {fileList.map(mapFiles)}
            </div>
          </>
        )
        : <Empty message={'ללא קבצים מצורפים'} customContainerClassName={styles.empty}/>
      }
    </>
  );
}
